import React, { useEffect, useState } from "react"

export default function WithWindowDimensions(WrappedComponent) {
  return (props) => {
    const [width, setWidth] = useState(typeof window !== "undefined" ? window.innerWidth : 0)
    const [height, setHeight] = useState(typeof window !== "undefined" ? window.innerHeight : 0)
    const [typingTimeout, setTypingTimeout] = useState(0)

    useEffect(() => {
      updateWindowDimensions()

      window.addEventListener("resize", updateWindowDimensions)
      return () => {
        window.removeEventListener("resize", updateWindowDimensions)
      }
    }, [])
    
    const updateWindowDimensions = () => {
      let windowWidth = typeof window !== "undefined" ? window.innerWidth : 0
      let windowHeight = typeof window !== "undefined" ? window.innerHeight : 0
      
      if (typingTimeout) {
        clearTimeout(typingTimeout)
      }
      
      if(width !== 0) {
        setTypingTimeout(
          setTimeout(function () {
            setWidth(windowWidth)
            setHeight(windowHeight)
          }, 1000)
        )
      }
    }
    return (
      <WrappedComponent
        {...props}
        windowWidth={width}
        windowHeight={height}
        isSmallScreen={width < 768}
      />
    )
  }
}